export const AI_CHAT_TURNSTILE_ACTION = 'ai_chat_message';
export const AI_CHAT_SESSION_TURNSTILE_ACTION = 'ai_chat_session';

export type AiChatTurnstileMode = 'message' | 'session';

export type AiChatMessage = {
  role: 'user' | 'assistant';
  content: string;
};
